import { render } from "./UserDetailView.vue?vue&type=template&id=04ac3bc0"
import script from "./UserDetailView.vue?vue&type=script&lang=js"
export * from "./UserDetailView.vue?vue&type=script&lang=js"

import "./UserDetailView.vue?vue&type=style&index=0&id=04ac3bc0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__